import type { RateRow, SessionSelectorElementData } from '../types/sessions'

export const recordingRates: RateRow[] = [
  { label: 'Weekday (10am-6pm)', regular: 600, promo: 500, active: false },
  { label: 'Weeknight (6pm-10pm)', regular: 300, promo: 250, active: false },
  { label: 'Weekend day (10am-6pm)', regular: 650, promo: 550, active: false },
  {
    label: 'Weekend night (6pm-10pm)',
    regular: 350,
    promo: 300,
    active: false,
  },
]

export const rehearsalRates: RateRow[] = [
  { label: 'Weekday (10am-6pm)', regular: 315, promo: 250, active: false },
  { label: 'Weeknight (6pm-10pm)', regular: 157.5, promo: 125, active: false },
  { label: 'Weekend day (10am-6pm)', regular: 450, active: false },
  { label: 'Weekend night (7pm-11pm)', regular: 300, active: false },
]

export const sessions: SessionSelectorElementData[] = [
  {
    variables: {
      weekday: {
        type: 'inline',
        layout: 'month_view',
        calInstanceUrl: 'https://booking.strangeways.co',
        calendarPath: 'studio/a-weekday',
      },
      weeknight: {
        type: 'inline',
        layout: 'month_view',
        calInstanceUrl: 'https://booking.strangeways.co',
        calendarPath: 'studio/a-weeknight',
      },
      weekendNight: {
        type: 'inline',
        layout: 'month_view',
        calInstanceUrl: 'https://booking.strangeways.co',
        calendarPath: 'studio/a-weekend-night',
      },
      weekendDay: {
        type: 'inline',
        layout: 'month_view',
        calInstanceUrl: 'https://booking.strangeways.co',
        calendarPath: 'studio/a-weekend-day',
      },
      rehearsalWeeknight: {
        type: 'inline',
        layout: 'month_view',
        calInstanceUrl: 'https://booking.strangeways.co',
        calendarPath: 'studio/rehearsal-weeknight',
      },
      rehearsalWeekday: {
        type: 'inline',
        layout: 'month_view',
        calInstanceUrl: 'https://booking.strangeways.co',
        calendarPath: 'studio/rehearsal-weekday',
      },
      rehearsalWeekendDay: {
        type: 'inline',
        layout: 'month_view',
        calInstanceUrl: 'https://booking.strangeways.co',
        calendarPath: 'studio/rehearsal-weekend-day',
      },
      rehearsalWeekendNight: {
        type: 'inline',
        layout: 'month_view',
        calInstanceUrl: 'https://booking.strangeways.co',
        calendarPath: 'studio/rehearsal-weekend-night',
      },
      type: 'inline',
      layout: 'month_view',
      calInstanceUrl: 'https://booking.strangeways.co',
      calendarPath: 'studio/15min',
    },
  },
]
